document.addEventListener('DOMContentLoaded', function() {
    Swatches.init();
  });
  
  const Swatches = {
      selectors: {
        "swatchContainers": { selector: ".swatch-options", type: "all", scope: "document" },
        "swatchBtns": { selector: ".product-card .swatch-btn", type: "all", scope: "document" },
        "rightArrows": { selector: ".swatch-right", type: "all", scope: "document" },
        "leftArrows": { selector: ".swatch-left", type: "all", scope: "document" },
      },
    
      init: async function() { 
          Utility.fetchEls(this.selectors, this);
          this.initEventListeners();
      },
    
      initEventListeners: function() {
        const {swatchBtns, rightArrows, leftArrows } = this;
  
        if (swatchBtns) {
          swatchBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
              this.handleSwatchChange(btn);
            });
          });
        }
  
        if (rightArrows) {
          rightArrows.forEach((arrow) => {
            arrow.addEventListener('click', () => {
                const container = arrow.closest('.product-swatches').querySelector('.swatch-options');
                if (container.scrollLeft + container.clientWidth < container.scrollWidth) {
                    Utility.smoothScroll(container, 100, 300);
                }
        
                setTimeout(() => {
                    this.updateArrows(container);
                }, 350);
            });
          });
        }
  
        if (leftArrows) {
          leftArrows.forEach((arrow) => {
            arrow.addEventListener('click', () => {
                const container = arrow.closest('.product-swatches').querySelector('.swatch-options');
                if (container.scrollLeft > 0) {
                    Utility.smoothScroll(container, -100, 300);
                }
        
                setTimeout(() => {
                    this.updateArrows(container);
                }, 350);
            });
          });
        }
      },
      
      updateArrows: function(container) {
          const leftArrow = container.closest('.product-swatches').querySelector('.swatch-left');
          const rightArrow = container.closest('.product-swatches').querySelector('.swatch-right');
          const maxScrollLeft = container.scrollWidth - container.clientWidth;
          const scrollLeft = container.scrollLeft;
          
          // Update left arrow
          if (scrollLeft <= 0) {
              leftArrow.classList.remove('active');
          } else {
              leftArrow.classList.add('active');
          }
      
          // Update right arrow
          if (scrollLeft >= maxScrollLeft) {
              rightArrow.classList.remove('active');
          } else {
              rightArrow.classList.add('active');
          }
      },
    
      handleSwatchChange: function(btn) {
          btn.classList.add('selected');
          const productCard = btn.closest('.product-card');
          const swatchBtns = productCard.querySelectorAll('.swatch-btn');
          swatchBtns.forEach((btn) => {
            btn.classList.remove('selected');
          });
          btn.classList.add('selected');
          const swatchImage = btn.querySelector('img').src;
          const image = productCard.querySelector('.img-container img');
          image.src = swatchImage.split('&width')[0];
          const nextImg = btn.dataset.nextImg;
          const firstImg = btn.dataset.firstImg;
          if (nextImg && firstImg) {
            image.dataset.nextImg = nextImg;
            image.dataset.firstImg = firstImg;
          }
          const links = productCard.querySelectorAll('a');
          links.forEach((link) => {
            link.href = btn.querySelector('img').dataset.variantUrl;
          });
          const input = productCard.querySelector('.product-id-input');
          if (input) {
            input.value = swatchImage.dataset.variantId;
          }
          const compareModalElement = document.querySelector('#compare-modal');
          if (compareModalElement) {
            productCard.setAttribute('data-variant-id', swatchImage.dataset.variantId);
            productCard.querySelector('.compare-button').setAttribute('data-variant-id', swatchImage.dataset.variantId);
          }
  
          const price = parseInt(btn.dataset.price) / 100;
          const comparePrice = parseInt(btn.dataset.comparePrice) / 100;
          if (!comparePrice || comparePrice == price) {
            productCard.querySelector('.prices').innerHTML = `<span class="price">$${price}</span>`;
            const saleLabel = productCard.querySelector('.sale-label');
            if (saleLabel) {
              saleLabel.style.display = 'none';
            }
          } else {
            const saleLabel = productCard.querySelector('.sale-label');
            if (saleLabel) {
              saleLabel.style.display = 'block';
            }
            productCard.querySelector('.prices').innerHTML = 
              `<span class="compare-price">$${comparePrice}</span><span class="price on-sale">$${price}</span>`;
          }
      },
  
      initSwatchesScroll: function() {
          const { swatchContainers } = this;
      
          swatchContainers.forEach((container) => {
              const parent = container.closest('.product-swatches');
          });
      }
  };